import "./header.css";
import { useState } from "react";
import UserIcon from "../images/user_icon.png";
import BurgerIcon from "../images/doc-icon.png"; // Import burger icon
import { useLocation } from "react-router-dom";
import Adminsettings from "../pages/admin-settings";
import { Link } from "react-router-dom";
import MyGptsPopup from "../pages/my-gpts"; // Import the My GPTs popup component

const Header = ({ onBurgerClick }) => {  // Accept the burger click handler as a prop
  const [profilePanel, openProfilePanel] = useState(false);
  const [showAdminSettings, setShowAdminSettings] = useState(false);
  const [showMyGpts, setShowMyGpts] = useState(false); // State for My GPTs popup

  const handleAdminSettingsClick = () => {
    setShowAdminSettings(true);
  };

  const handleCloseAdminSettings = () => {
    setShowAdminSettings(false);
  };

  const handleSaveAdminSettings = () => {
    // setShowAdminSettings(false);
  };

  const location = useLocation();

  const handleProfileClick = () => {
    openProfilePanel(!profilePanel);
  };
  const handleOverlayClick = () => {
    openProfilePanel(false);
  };

  const handleMyGptsClick = () => {
    setShowMyGpts(true);
  };

  const handleCloseMyGpts = () => {
    setShowMyGpts(false);
  };

  if (location.pathname.includes("chat")) {
    return (
      <div className="MainHeader">
        <div className="d-flex align-items-center">
          {/* Burger Icon - Visible only on small screens */}
          <div className="burger-container" onClick={onBurgerClick}>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-list" viewBox="0 0 16 16">
              <path fillRule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5" />
            </svg>
          </div>

          <h1 className="m-0 ps-2 pe-2">Tranquilla AI</h1>
          {
            sessionStorage.getItem('userType') === 'user' &&
            <>
            {/* <img src={UserIcon} /> */}
            <div className="ps-3 border-start">{sessionStorage.getItem('agentName')}</div>
            </>
          }
          
        </div>

        <div className="profileContainer">
          <img
            src={UserIcon}
            onClick={handleProfileClick}
            style={{ cursor: "pointer" }}
            alt="Profile"
          />
          {profilePanel && (
            <>
              <div className="overlay" onClick={handleOverlayClick}>
                <div className="profilePanel">
                  {/* {(sessionStorage.getItem('userType') === 'admin') && (
                    <>
                      <span
                        className="admin-settings"
                        onClick={handleAdminSettingsClick}
                        style={{ cursor: "pointer" }}
                      >
                        Admin settings
                      </span>
                      <hr />
                      <span className="mt-2 cursor-pointer" onClick={handleMyGptsClick}>
                        My GPTs
                      </span>
                      <hr />
                    </>
                  )} */}
                  <span className="mb-0">
                    <div className="email" style={{ fontSize: '15px', wordBreak: 'break-all', maxWidth: '140px' }}>
                      {sessionStorage.getItem('user_id')}
                    </div>
                    <div onClick={() => sessionStorage.clear()} className="logout" style={{ cursor: "pointer" }}>
                      <Link to={((sessionStorage.getItem('userType')==='user') && sessionStorage.getItem('agentName')) ? "/?agentName="+sessionStorage.getItem('agentName') : "/"} style={{ textDecoration: "none" }}>
                        Log out
                      </Link>
                    </div>
                  </span>
                </div>
              </div>
            </>
          )}
        </div>

        {showAdminSettings && (
          <Adminsettings
            onClose={handleCloseAdminSettings}
            onSave={handleSaveAdminSettings}
          />
        )}

        {showMyGpts && (
          <MyGptsPopup onClose={handleCloseMyGpts} />
        )}
      </div>
    );
  } else {
    return <div className="MainHeader"></div>;
  }
};

export default Header;
